// Ingyenes szállítás jelző. A tartó a téma kosár-eseményére (kosárba tétel, darabszám-változás, törlés) újrakéri
// a saját szekcióját, és a sávot az előző állásból tölti az újba. A téma meglévő JS-fájljaihoz így nem nyúlunk.
// A sáv alá a hiányzó összeghez illő palackot tölt (sections/szallitas-ajanlo.liquid), egy kattintással kosárba tehetőt.
if (!customElements.get('szallitas-sav-tarto')) {
  customElements.define(
    'szallitas-sav-tarto',
    class SzallitasSavTarto extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const gomb = event.target.closest('[data-szallitas-ajanlo]');
          if (gomb) this.kosarba(gomb);
        });

        // a felugró ablak rejtve töltődik be: ott csak kosárba tételkor kell ajánlat
        if (!this.closest('cart-notification')) this.ajanl();

        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.leiratkozas = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          this.frissit();
        });
      }

      disconnectedCallback() {
        if (this.leiratkozas) this.leiratkozas();
      }

      frissit() {
        const szekcio = this.dataset.section;
        if (!szekcio) return;
        const regi = this.querySelector('.szallitas-sav');
        const elozo = regi ? Number(regi.dataset.pct) : 0;

        fetch(`${window.routes.cart_url}?section_id=${encodeURIComponent(szekcio)}`)
          .then((response) => response.text())
          .then((html) => {
            const uj = new DOMParser().parseFromString(html, 'text/html').querySelector('szallitas-sav-tarto');
            if (!uj) return;
            this.innerHTML = uj.innerHTML;
            this.tolt(elozo);
            this.ajanl();
          })
          .catch((e) => {
            console.error(e);
          });
      }

      tolt(elozo) {
        const sav = this.querySelector('.szallitas-sav');
        const toltes = sav && sav.querySelector('.szallitas-sav__toltes');
        if (!toltes) return;
        const cel = Number(sav.dataset.pct) || 0;
        if (elozo === cel || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        toltes.style.width = `${elozo}%`;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            toltes.style.width = `${cel}%`;
          });
        });
      }

      ajanl() {
        const hely = this.querySelector('.szallitas-sav__ajanlo');
        if (!hely) return;
        const hiany = Math.ceil(Number(hely.dataset.hiany) / 100);
        if (!hiany) return;
        // a gyűjtemény ár szerinti rendezésére nem lehet építeni, a szekció pedig 50 találatból választ:
        // ezért egyre tágabb ársávban keresünk, az elsőből, ahol van palack, a legolcsóbbat kapjuk
        const savok = [500, 1500, 5000, null];
        const kovetkezo = (i) => {
          if (i >= savok.length) return;
          this.ajanloKeres(hely, hiany, savok[i] === null ? null : hiany + savok[i]).then((talalt) => {
            if (!talalt) kovetkezo(i + 1);
          });
        };
        kovetkezo(0);
      }

      ajanloKeres(hely, also, felso) {
        const gyoker = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const cim =
          `${gyoker}collections/bor?filter.v.price.gte=${also}` +
          (felso ? `&filter.v.price.lte=${felso}` : '') +
          '&filter.v.availability=1&sort_by=price-ascending&section_id=szallitas-ajanlo';

        return fetch(cim)
          .then((response) => response.text())
          .then((html) => {
            const ajanlo = new DOMParser().parseFromString(html, 'text/html').querySelector('.szallitas-ajanlo');
            if (!ajanlo || !ajanlo.querySelector('[data-szallitas-ajanlo]')) return false;
            if (hely.isConnected) hely.innerHTML = ajanlo.outerHTML;
            return true;
          })
          .catch((e) => {
            console.error(e);
            return true;
          });
      }

      kosarba(gomb) {
        gomb.disabled = true;
        gomb.setAttribute('aria-busy', 'true');

        fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(gomb.dataset.szallitasAjanlo), quantity: 1 }],
            sections: 'cart-icon-bubble',
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((valasz) => {
            if (valasz.status) throw new Error(valasz.description || valasz.message);

            // a kosároldalon a tételek és a részösszeg is változik: a teljes oldal a biztos
            if (window.location.pathname.startsWith(window.routes.cart_url)) {
              window.location.reload();
              return;
            }

            const buborek = document.getElementById('cart-icon-bubble');
            const uj = valasz.sections && valasz.sections['cart-icon-bubble'];
            if (buborek && uj) {
              const tartalom = new DOMParser().parseFromString(uj, 'text/html').querySelector('.shopify-section');
              if (tartalom) buborek.innerHTML = tartalom.innerHTML;
            }
            if (typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'szallitas-ajanlo', cartData: valasz });
            } else {
              this.frissit();
            }
          })
          .catch((e) => {
            console.error(e);
            gomb.disabled = false;
            gomb.removeAttribute('aria-busy');
          });
      }
    }
  );
}
